export const colourSwatchSelectorControlSize = '32px';
export const colourSwatchSelectorWidth = colourSwatchSelectorControlSize;
